import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { ApiError } from "@finora/api-client";
import { Button } from "@finora/ui";
import { api } from "../../lib/api";

/**
 * Registracija - vidi razgovor "za registraciju me nisi poslusao ... samo
 * email i ime". Signup od sada NE traži lozinku ni podatke o firmi - šalje
 * mail sa linkom ("Potvrda naloga") na kome korisnik TEK postavlja lozinku
 * (vidi ConfirmAccountPage.tsx). Firma se pravi kasnije, u onboarding
 * "Kompanija" koraku (vidi CompanyStep.tsx).
 */
export function SignupPage() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");

  const mutation = useMutation({
    mutationFn: () => api.signup({ fullName, email }),
  });

  if (mutation.isSuccess) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-app-bg px-4 py-10">
        <div className="w-full max-w-md rounded-xl border border-border bg-surface p-8 text-center shadow-subtle">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-light text-brand">
            <MailCheck className="h-7 w-7" />
          </div>
          <h1 className="mb-2 text-xl font-semibold text-slate-900">Proverite email</h1>
          <p className="text-sm text-slate-500">{mutation.data.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-app-bg px-4 py-10">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
        className="w-full max-w-md rounded-xl border border-border bg-surface p-6 shadow-subtle"
      >
        <h1 className="mb-1 text-xl font-semibold text-slate-900">Napravite HAFiskal nalog</h1>
        <p className="mb-6 text-sm text-slate-500">
          Poslaćemo vam mail sa linkom za potvrdu naloga - podatke o firmi unosite kasnije.
        </p>

        <div className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Ime i prezime</label>
            <input
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
              required
            />
          </div>

          {mutation.isError && (
            <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
              {mutation.error instanceof ApiError
                ? mutation.error.response.message
                : "Registracija nije uspela. Pokušajte ponovo."}
            </p>
          )}

          <Button type="submit" className="w-full" disabled={mutation.isPending}>
            {mutation.isPending ? "Šaljem..." : "Pošalji link za potvrdu"}
          </Button>

          <p className="text-center text-sm text-slate-500">
            Već imate nalog?{" "}
            <Link to="/prijava" className="text-brand hover:underline">
              Prijavite se
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}
